/**
 * Adds +/- buttons to an input field
 */
(function($){
	"use strict";
	$.widget('ui.spinner', {
		
		options: {
			min: 0
		},
		
		wrapper: null,
		buttonWrapper: null,
		upButton: null,
		downButton: null,
		
		_create: function(){
			var self = this;
			
			if(this.element.is('.spin_d')) return; // Do not initialise again
			this.element.addClass('spin_d spin-input');
			
			this.wrapper = $('<div class="spin-wrapper"></div>');
			this.buttonWrapper = $('<div class="button-wrapper"></div>');
			this.downButton = $('<button type="button">Decrease</button>').addClass('spinDown');
			this.upButton = $('<button type="button">Increase</button>').addClass('spinUp');
			
			this.upButton.button({
				text: false,
				icons: {
					primary: 'ui-icon-triangle-1-n'
				}
			}).removeClass('ui-corner-all');
			this.downButton.button({
				text: false,
				icons: {
					primary: 'ui-icon-triangle-1-s'
				}
			}).removeClass('ui-corner-all');
			
			this.upButton.click(function(){ self.increase(); });
			this.downButton.click(function(){ self.decrease(); });
			this.element.keydown(function(e){
				if(e.which === 38){ 
					// up arrow
					self.increase();
				}else if(e.which === 40){ 
					// down arrow
					self.decrease();
				}
			});
			
			this.element.after(this.wrapper);
			this.wrapper.append(this.element).append(this.buttonWrapper);
			this.buttonWrapper.append(this.upButton).append(this.downButton);
		},
		_add: function(add){
			if(this._isElementDisabled()) return;
			var newVal = this._getCurrentNumber() + add;
			
			// Check for a min value
			if(newVal < this.options.min){
				this.element.val(this.options.min);
				return;
			}
			this.element.val(newVal).change().trigger('spinran');
		},
		_isElementDisabled: function(){
			return this.element.is(':disabled');
		},
		_getCurrentNumber: function(){
			var r = parseInt(this.element.val());
			if(!$.isNumeric(r)) return 0;
			return r;
		},
		increase: function(){
			this._add(1);
		},
		decrease: function(){
			this._add(-1);
		}
		
	});
})(jQuery);